import { Grid, Skeleton, Stack } from '@mantine/core';
import React from 'react';
import Card from '../../components/elements/Card';

const LoaderDetailVoucher = () => {
  return (
    <Grid>
      <Grid.Col span={{ base: 12, md: 8 }} order={{ base: 2, md: 1 }}>
        <Card>
          <Skeleton height={300} radius="sm" />
        </Card>
      </Grid.Col>
      <Grid.Col span={{ base: 12, md: 4 }} order={{ base: 2, md: 1 }}>
        <Card>
          <Stack>
            <Skeleton height={100} radius="sm" />
            <Skeleton height={24} radius="sm" />
            <Skeleton height={24} radius="sm" />
          </Stack>
        </Card>
      </Grid.Col>
    </Grid>
  );
};

export default LoaderDetailVoucher;
